import * as React from "react";
function SvgFortmatic(props, svgRef) {
  return <svg width={34} height={35} fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M17 0h17v8.762H8.5v26.235H0V0h17zm8.5 26.238h-8.45v-8.711h16.945v9.017a8.59 8.59 0 0 1-2.4 5.978A8.08 8.08 0 0 1 25.798 35H25.5v-8.762z" fill="#6851FF" /></svg>;
}
const ForwardRef = React.forwardRef(SvgFortmatic);
export default __webpack_public_path__ + "node_modules/use-wallet/dist/esm/Fortmatic.svg";
export const Scaled = {
  "0.5x": __webpack_public_path__ + "node_modules/use-wallet/dist/esm/Fortmatic_0.5x.svg",
  "1x": __webpack_public_path__ + "node_modules/use-wallet/dist/esm/Fortmatic_1x.svg",
  "2x": __webpack_public_path__ + "node_modules/use-wallet/dist/esm/Fortmatic_2x.svg",
  "3x": __webpack_public_path__ + "node_modules/use-wallet/dist/esm/Fortmatic_3x.svg",
  "4x": __webpack_public_path__ + "node_modules/use-wallet/dist/esm/Fortmatic_4x.svg"
};
export { ForwardRef as ReactComponent };